import React, {useEffect, useState} from "react";
import {callApi} from "../../../connection/ClientApi";
import Urls from "../../../connection/Urls";
import ImageProductList from "../dynamicLict/ImageProductList";
import TitleProductList from "../dynamicLict/TitleProductList";
import messages from "res/messages/farsi";
import {basketViewModel} from "../../../viewModels/Basket.viewModel";

export default function ProductList(props) {

    const [products, setProducts] = useState([])

    function requestProductList() {
        if (products.length <= 0) {
            let params = new FormData()
            params.append("header_id", props.data.header.id)
            callApi(Urls.getProductsForDynamicList, params, (data) => {
                setProducts(basketViewModel.checkLocalBasket(data.list))
            }, () => {
                props.onListIsEmpty()
                setProducts([])
                props.onAlert(messages.responseCodeIsNot200)
            }, () => {
                props.onLoading(true)
            }, () => {
                props.onLoading(false)
            })
        }
    }

    function getProductListByType() {
        if (props.data !== undefined && props.data.lines.length > 0) {
            if (props.data.header.show_type === "1") {
                return getTitleProductList()
            } else {
                return getImageProductList()
            }
        }
    }

    function getImageProductList() {
        return <ImageProductList
            {...props}
            products={products}
            header={getProductListInfo(props.data)}
            onAllClicked={() => {
                props.onAllClicked()
            }}/>
    }

    function getTitleProductList() {
        return <TitleProductList
            {...props}
            products={products}
            header={getProductListInfo(props.data)}
            onAllClicked={() => {
                props.onAllClicked()
            }}/>
    }

    function getProductListInfo(data) {
        return {
            id: data.header.id,
            on_more: data.lines[0].on_more,
            title: data.header.title,
            titleColor: data.header.title_color,
            backgroundColor: data.header.background_color,
            backgroundImage: data.header.background_image,
            font_size_title: data.header.font_size_title,
            image: data.header.image
        }
    }

    useEffect(() => {
        requestProductList()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return getProductListByType()

}